<li class="router-tab-item" [routerLink]="route" [queryParams]="queryParams" routerLinkActive="active">
    <a routerLinkActive="active">
        <ng-content></ng-content>
    </a>
</li>